import styled from 'styled-components';

const AccordionTitle = styled.span`
  text-decoration: underline;
`;

export default AccordionTitle;
